document.addEventListener('DOMContentLoaded', () => {
  const countEl = document.getElementById('pack-count');
  const addToCart = document.getElementById('add-pack-to-cart');
  const messageEl = document.getElementById('pack-message');
  const items = document.querySelectorAll('.pack-item');

  if (!countEl || !addToCart) return;

  function updateCount() {
    let total = 0;
    items.forEach((item) => {
      const qty = parseInt(item.querySelector('.pack-qty').value) || 0;
      total += qty;
    });
    countEl.textContent = total;
    addToCart.disabled = total < 2;
  }

  items.forEach((item) => {
    const qtyInput = item.querySelector('.pack-qty');
    const increase = item.querySelector('.increase');
    const decrease = item.querySelector('.decrease');

    increase.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
      updateCount();
    });

    decrease.addEventListener('click', () => {
      qtyInput.value = Math.max(0, parseInt(qtyInput.value) - 1);
      updateCount();
    });

    qtyInput.addEventListener('input', () => {
      qtyInput.value = Math.max(0, parseInt(qtyInput.value) || 0);
      updateCount();
    });
  });

  addToCart.addEventListener('click', async () => {
    let totalProducts = 0;
    const itemsToAdd = [];

    items.forEach((item) => {
      const qty = parseInt(item.querySelector('.pack-qty').value) || 0;
      if (qty > 0) {
        totalProducts += qty;
        itemsToAdd.push({ id: item.dataset.productId, quantity: qty });
      }
    });

    if (totalProducts < 2) {
      messageEl.textContent = 'Debes seleccionar al menos 2 productos para crear tu pack.';
      return;
    }

    messageEl.textContent = '';

    for (const item of itemsToAdd) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.id, quantity: item.quantity, properties: { '_pack_item': 'true' } }),
      });
    }

    window.location.href = '/cart';
  });

  // Pre-rellenar cantidades desde el carrito al volver a la página
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      cart.items
        .filter(item => item.properties && item.properties['_pack_item'] === 'true')
        .forEach(cartItem => {
          const match = Array.from(items).find(
            el => el.dataset.productId === String(cartItem.variant_id)
          );
          if (match) {
            match.querySelector('.pack-qty').value = cartItem.quantity;
          }
        });
      updateCount();
    });
});
